exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-result-view{height:100%}.result-contents{margin-top:5px;height:calc(100% - 60px);overflow-y:scroll;overflow-x:hidden}.download-control{width:100%;margin-bottom:5px}.panel-footer{padding:5px!important}.dropdown{position:relative;z-index:10}.dropdown-menu{padding-left:10px;padding-right:10px}.select-all{position:absolute;width:calc(100% - 10px);bottom:0;margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/~/eoxc/src/search/views/SearchResultView.css
// module id = 1985
// module chunks = 0